'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import type { ComponentProps } from 'react';
type OnboardingExitButtonProps = ComponentProps<'button'> & {
  href?: string;
};
function storeAndBlankIframe(iframe: HTMLIFrameElement) {
  const currentSrcAttr = iframe.getAttribute('src');
  const currentSrc = currentSrcAttr ?? iframe.src;
  if (!iframe.dataset.originalSrc && currentSrc && currentSrc !== 'about:blank') {
    iframe.dataset.originalSrc = currentSrc;
  }
  iframe.src = 'about:blank';
  iframe.removeAttribute('src');
}
export function OnboardingExitButton(t0) {
  const $ = _c(11);
  let onClick;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      href: t1,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = onClick;
    $[2] = rest;
    $[3] = t1;
  } else {
    onClick = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const href = t1 === undefined ? "/" : t1;
  const router = useRouter();
  let t2;
  if ($[4] !== href || $[5] !== onClick || $[6] !== router) {
    t2 = event => {
      const iframes = document.querySelectorAll("iframe");
      iframes.forEach(_temp);
      onClick?.(event);
      if (!event.defaultPrevented) {
        router.push(href);
      }
    };
    $[4] = href;
    $[5] = onClick;
    $[6] = router;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  let t3;
  if ($[8] !== handleClick || $[9] !== rest) {
    t3 = <button type="button" onClick={handleClick} {...rest} />;
    $[8] = handleClick;
    $[9] = rest;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(iframe) {
  storeAndBlankIframe(iframe);
}